import { changePasswordStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePassword";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

changePasswordStyles.userInformationTitle = {
    variant: "h4",
    as: "h2",
    css: css`
    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-left : 11px;
                    padding-right : 11px;
                    `,
                css`
                    padding-left : 11px;
                    padding-right : 11px;
                    `,
                null,
                null,
                null,
            ])}
    `
}

changePasswordStyles.passwordRequirementsGridContainer = {
    gap: 2,
    css: css`
            margin-bottom: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-left : 11px;
                    padding-right : 11px;
                    `,
                css`
                    padding-left : 11px;
                    padding-right : 11px;
                    `,
                null,
                null,
                null,
            ])}
        `,
}
changePasswordStyles.passwordGridContainer = {
    css: css`
    margin: 0;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                padding-left : 11px;
                padding-right : 11px;
                    `,
            css`
                padding-left : 11px;
                padding-right : 11px;
                    `,
            css`
                max-width: 300px;
            `,
            css`
                max-width: 300px;
            `,
            css`
                max-width: 300px;
            `,
        ])}
`,
gap: 10,
}